import { render, staticRenderFns } from "./OrderOrBind.vue?vue&type=template&id=fc133d16&scoped=true"
import script from "./OrderOrBind.vue?vue&type=script&lang=js"
export * from "./OrderOrBind.vue?vue&type=script&lang=js"
import style0 from "./OrderOrBind.vue?vue&type=style&index=0&id=fc133d16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc133d16",
  null
  
)

export default component.exports